
import './App.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';



import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Contact from './components/pages/Contact';
import Aboutus from './components/pages/Aboutus';
import Productpage from './components/pages/Productpage';
import Youtubepage from './components/pages/Youtubepage';
import Licensepage from './components/pages/Licensepage';

function App() {
  return (
      <Router>

      <div>



        <Routes>


          <Route axact path="/" element={<Home />} />
            <Route axact path="/contact-us" element={<Contact />} />
                 <Route axact path="/aboutus" element={<Aboutus />} />
                   <Route axact path="/Products" element={<Productpage/>} />
                     <Route axact path="/video-gallery" element={<Youtubepage/>} />
                         <Route axact path="/Licensing-Services" element={<Licensepage/>} />
                </Routes>
      <Footer/>

      </div>

    </Router>
  );
}

export default App;
